import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { DateStyles } from '../../constants/CentricConstants';
import { Card, CardTitle } from 'material-ui/Card';

import DetailView from '../Common/DetailView';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';

import EventActions from '../../actions/EventActionCreator';
import EventAttendeeStore from '../../stores/EventAttendeeStore';
import EventStore from '../../stores/EventStore';

class EventAttendeesPrintView extends Component {

    componentDidMount() {
        this.onEventChange = this.onEventChange.bind(this);
        this.eventListener = EventStore.addListener(this.onEventChange);
        EventActions.getAttendees(this.state.eventId, { role: 'delegate' });
        EventActions.getById(this.state.eventId);
    }

    componentWillUnmount() {
        this.eventListener.remove();
    }

    render() {
        const tableProps = {
            selectable: false
        };

        const tableHeaderProps = {
            displaySelectAll: false,
            adjustForCheckbox: false,
        };

        const tableBodyProps = {
            displayRowCheckbox: false,
        };

        return (
            <DetailView title='Attendance list' backButton >
                <Card>
                    <CardTitle
                        title={this.state.title}
                        subtitle={`${this.state.venue} - ${this.state.date}`}
                    />
                    <Table {...tableProps}>
                        <TableHeader {...tableHeaderProps}>
                            <TableRow>
                                <TableHeaderColumn>Attendee</TableHeaderColumn>
                                <TableHeaderColumn>Date</TableHeaderColumn>
                                <TableHeaderColumn>Signature</TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody {...tableBodyProps}>
                            {this.state.attendees.map((a) => (
                                <TableRow>
                                    <TableRowColumn>{`${a.title || ''} ${a.firstName || ''} ${a.lastName || ''}`.trim()}</TableRowColumn>
                                    <TableRowColumn/>
                                    <TableRowColumn/>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Card>
            </DetailView>
        );
    }

    onEventChange() {
        const event = EventStore.getById(this.state.eventId);
        if (!!event) {
            this.setState({
                title: `${event.name}`,
                date: new Date(event.timeStart).toLocaleString('en-GB', DateStyles.shortDateTime),
                venue: event.venue || ''
            });
        }
    }
}

EventAttendeesPrintView.getStores = () => ([EventAttendeeStore]);
EventAttendeesPrintView.calculateState = (prevState, {routeParams}) => {
    if (!prevState) {
        prevState = {
            eventId:    Number(routeParams.id),
            title:      '',
            date:       '',
            venue:      '',
        };
    }
    return {
        ...prevState,
        attendees: EventAttendeeStore.getByEvent(prevState.eventId),
    };
};

export default Container.create(EventAttendeesPrintView, {withProps: true});
